import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';

import createRootReducer from '../redux';
import rootSaga from 'src/sagas';

// creates the store
/* ------------- Redux Configuration ------------- */

/* ------------- Logger Middleware ------------- */
const logger = createLogger();

/* ------------- Saga Middleware ------------- */
const sagaMiddleware = createSagaMiddleware();

/* ------------- History Middleware ------------- */
const history = createBrowserHistory();
const historyMiddleware = routerMiddleware(history);

/* ------------- Assemble Middleware ------------- */

const rootReducer = createRootReducer(history);

export type IAppState = ReturnType<typeof rootReducer>;

const composeEnhancers =
  typeof window === 'object' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(historyMiddleware, sagaMiddleware)));

sagaMiddleware.run(rootSaga);

export default () => ({
  store,
  history,
});
